import React from 'react';
import './About.css';
const About = () => {
  return (
    <main className="about-main">
      <div className="about-hero">
        <div className="about-hero-content">
          <h1>About Wonder Eventzz</h1>
          <p>Making your celebrations memorable since 2020</p>
        </div>
      </div>

      <div className="about-content">
        <div className="about-section">
          <div className="about-text">
            <h2>Our Story</h2>
            <p>
              Wonder Eventzz was born from a simple belief: every celebration deserves to be extraordinary. 
              What started as a small team of passionate event planners in Noida has grown into 
              one of the most trusted names in party planning across the region.
            </p>
            <p>
              We understand that every event is unique, whether it's a child's birthday party, 
              a corporate gathering, or a festive celebration. That's why we've built our 
              services around flexibility, creativity, and attention to detail.
            </p>
          </div>
          <div className="about-image">
            <div className="image-placeholder">
              🎉
            </div>
          </div>
        </div>

        <div className="about-section reverse">
          <div className="about-text">
            <h2>Our Mission</h2>
            <p>
              To create unforgettable experiences that bring people together and celebrate 
              life's special moments. We believe that every party should reflect the unique 
              personality and style of our clients.
            </p>
            <p>
              From intimate gatherings to grand celebrations, we handle every detail so you 
              can focus on enjoying the moment with your loved ones.
            </p>
          </div>
          <div className="about-image">
            <div className="image-placeholder">
              🎊
            </div>
          </div>
        </div>

        <div className="stats-section">
          <h2>Our Achievements</h2>
          <div className="stats-grid">
            <div className="stat-card">
              <div className="stat-number">500+</div>
              <div className="stat-label">Events Organized</div>
            </div>
            <div className="stat-card">
              <div className="stat-number">1000+</div>
              <div className="stat-label">Happy Customers</div>
            </div>
            <div className="stat-card">
              <div className="stat-number">50+</div>
              <div className="stat-label">Event Categories</div>
            </div>
            <div className="stat-card">
              <div className="stat-number">4.9</div>
              <div className="stat-label">Customer Rating</div>
            </div>
          </div>
        </div>
      </div>
    </main>
  );
};

export default About;
